class TabList extends HTMLElement {
  constructor() {
    super();
    this.initElements();
  }

  initElements() {
    this.tabList = this.querySelector('[role="tablist"]');
    this.tabs = this.tabList ? this.tabList.querySelectorAll(':scope > [role="tab"]') : [];
    this.tabPanels = this.querySelectorAll('[role="tabpanel"]');

    this.tables = this.querySelectorAll('table');
    this.tds = this.querySelectorAll('td');

    this.convertCmInch = this.querySelectorAll('input[type="checkbox"]');
    this.measurements = this.querySelectorAll('button[data-cm]');

    this.variantButtons = this.querySelectorAll('td button[data-variant-id]');
    this.atcButtons = this.querySelectorAll('cart-add-button');
  }

  connectedCallback() {
    this.setupTabs();
    this.setupHighlights();
    if (this.convertCmInch && this.measurements) {
      this.setupConversion();
      this.setDefault();
    }
    this.setupVariantClicks();
    this.updateVariantChange();
  }

  setupTabs() {
    if (this.tabs.length && this.tabPanels.length && this.tabList) {
      this.tabs.forEach((tab) => tab.addEventListener('click', this.changeTabs));
      this.tabList.addEventListener('keydown', this.handleTabKeydown.bind(this));
    }
  }

  handleTabKeydown(e) {
    let tabFocus = Array.from(this.tabs).indexOf(document.activeElement);
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      this.tabs[tabFocus].setAttribute('tabindex', -1);
      tabFocus = (tabFocus + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
      this.tabs[tabFocus].setAttribute('tabindex', 0);
      this.tabs[tabFocus].focus();
    }
  }

  changeTabs(e) {
    const targetTab = e.target;
    const tabGroup = targetTab.closest('[role="tablist"]').parentNode;
    tabGroup.querySelectorAll('[aria-selected="true"]').forEach((t) => t.setAttribute('aria-selected', false));
    targetTab.setAttribute('aria-selected', true);
    tabGroup.querySelectorAll('[role="tabpanel"]').forEach((p) => p.setAttribute('hidden', true));
    tabGroup.querySelector(`#${targetTab.getAttribute('aria-controls')}`).removeAttribute('hidden');
  }

  setupHighlights() {
    if (this.tables.length) {
      this.tables.forEach((table) => {
        table.addEventListener('mouseover', this.highlightCells.bind(this, table));
        table.addEventListener('mouseout', () =>
          table.querySelectorAll('td').forEach((td) => td.classList.remove('highlight')),
        );
      });
    }
  }

  highlightCells(table, e) {
    if (e.target.tagName === 'BUTTON' || e.target.tagName === 'TD') {
      const index = e.target.cellIndex !== undefined ? e.target.cellIndex : e.target.parentElement.cellIndex;
      const row =
        e.target.parentElement.sectionRowIndex !== undefined
          ? e.target.parentElement.sectionRowIndex
          : e.target.parentElement.parentElement.sectionRowIndex;

      table.querySelectorAll('td').forEach((td) => td.classList.remove('highlight'));

      table.querySelectorAll('tr').forEach((tr) => {
        let colIndex = 0;
        tr.querySelectorAll('td').forEach((td) => {
          const colSpan = td.colSpan || 1;
          if (colIndex <= index && index < colIndex + colSpan) {
            td.classList.add('highlight');
          }
          colIndex += colSpan;
        });
      });

      table.querySelectorAll(`tr:nth-child(${row + 1}) td`).forEach((td) => td.classList.add('highlight'));
    }
  }

  setupConversion() {
    this.convertCmInch.forEach((checkbox) => {
      checkbox.addEventListener('change', (event) => {
        this.handleConversion(event);
      });
    });
  }

  setDefault() {
    this.convertCmInch.forEach((c) => {
      if (c.checked) {
        this.handleConversion({ target: c });
      }
    });
  }

  handleConversion(event) {
    const isChecked = event.target.checked;

    this.convertCmInch.forEach((c) => {
      if (c !== event.target) {
        c.checked = isChecked;
      }
    });

    this.measurements.forEach((convert) => {
      const cm = convert.getAttribute('data-cm');

      if (cm.includes('-')) {
        const range = cm.split('-');
        convert.textContent = `${isChecked ? (range[0] * 0.3937).toFixed(1) : range[0]}-${isChecked ? (range[1] * 0.3937).toFixed(1) : range[1]}`;
        return;
      }

      convert.textContent = isChecked ? (cm * 0.3937).toFixed(1) : cm;
    });
  }

  setupVariantClicks() {
    if (this.atcButtons.length && this.variantButtons.length) {
      this.addEventListener('click', (e) => {
        if (e.target.tagName === 'BUTTON' && e.target.hasAttribute('data-variant-id')) {
          this.handleVariantChange(e.target.dataset.variantId, e.target.classList.contains('disabled'));
        }
      });
    }
  }

  updateVariantChange() {
    if (this.atcButtons.length && this.variantButtons.length) {
      window.addEventListener('variant:change', (e) => {
        const variantId = e.detail.variantId;
        const variantButton = this.querySelector(`button[data-variant-id="${variantId}"]`);
        if (!variantButton) return;
        this.handleVariantChange(variantId, variantButton.classList.contains('disabled'));
      });
    }
  }

  handleVariantChange(variantId, isOutOfStock) {
    this.tds.forEach((td) => td.classList.remove('active'));
    this.tds.forEach((td) => {
      if (td.querySelector(`[data-variant-id="${variantId}"]`)) {
        td.classList.add('active');
      }
    });
    this.updateATCButtons(variantId, isOutOfStock);
    this.updateURL(variantId);
  }

  updateATCButtons(variantId, isOutOfStock) {
    this.atcButtons.forEach((atcButton) => {
      const atcText = atcButton.querySelector('span');

      atcButton.setAttribute('variant-id', variantId);
      atcButton.querySelector('button').toggleAttribute('disabled', isOutOfStock);
      atcText.textContent = isOutOfStock ? atcButton.dataset.soldOut : atcButton.dataset.atc;
    });
  }

  updateURL(variantId) {
    if (this.atcButtons.length && this.variantButtons.length) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }
  }
}

customElements.define('tab-list', TabList);
